import React from "react";
import styles from "../../stories/common/flipper-vault-list-item/index.module.scss";
import SkeletonC from "../../stories/common/skeleton";

export default function FlipperVaultListSkeleton() {
  return (
    <div className={styles.FlipperVaultListItem}>
      <SkeletonC width="83px" height="19px" />
      <div className={styles.FlipperVaultListTitle}>
        <SkeletonC width="125px" height="19px" />
      </div>
      <div className={styles.FlipperVaultContactDropdown}>
        <SkeletonC width="120px" height="26px" />
        <img src="/images/call.svg" alt="" />
        <img src="/images/email.svg" alt="" />
        <div className={styles.FlipperVaultCardScore}>
          <SkeletonC width="70px" height="26px" />
        </div>
        <img src="/images/flipper-list-arrow.svg" alt="" />
      </div>
      <div className={styles.FlipperVaultCardOwner}>
        <SkeletonC width="225px" height="19px" />
      </div>
    </div>
  );
}
